import Link from "next/link";
import type { ReactNode } from "react";

import { cn } from "../../../lib/utils";
import { NavigationMenuLink } from "../../ui/navigation-menu";

export const NavListItem = ({
  path,
  label,
  subtitle,
  disabled,
  className,
}: {
  path: string;
  label: string | ReactNode;
  subtitle?: string;
  disabled?: boolean;
  className?: string;
}) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <Link
          aria-disabled={disabled}
          href={path}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            }
          }}
          className={cn(
            "block select-none p-3 pb-2 leading-none no-underline outline-none transition-opacity duration-300 hover:opacity-40",
            disabled && "pointer-events-none opacity-40",
            className,
          )}
        >
          <div className={"mb-0.5 font-title text-[0.85rem] font-bold leading-none"}>{label}</div>
          {subtitle && (
            <p className="line-clamp-2 font-title text-[0.85rem] font-medium leading-none opacity-75">
              {subtitle}
            </p>
          )}
        </Link>
      </NavigationMenuLink>
    </li>
  );
};
NavListItem.displayName = "NavListItem";
